<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p>To the memory of my grandmother, Lizzie Mudie: d. 1939</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?25362542